import { useState } from 'react'
import type { FormConfig } from '@workwave-tidal/core/form'
import { BulkDriverFormValues } from '../types'

export function useFormConfig(drivers: uui.domain.client.rm.ExtendedDriver[]) {
  const [formConfig] = useState<FormConfig<BulkDriverFormValues>>(() => ({
    id: 'bulkDriverForm',
    initialValues: computeInitialValues(drivers),
  }))

  return formConfig
}

function computeInitialValues(
  drivers: uui.domain.client.rm.ExtendedDriver[],
): BulkDriverFormValues {
  const firstDriver = drivers[0].driver
  const allMobileFutureDaysVisibilityEquals = drivers.every(
    d => d.driver.mobileFutureDaysVisibility === firstDriver.mobileFutureDaysVisibility,
  )
  const allSummarizeFutureMobileRoute = drivers.every(
    d => d.driver.summarizeFutureMobileRoute === firstDriver.summarizeFutureMobileRoute,
  )

  return {
    mobileFutureDaysVisibility: allMobileFutureDaysVisibilityEquals
      ? { status: 'exact', value: `${firstDriver.mobileFutureDaysVisibility}` }
      : { status: 'mixed' },
    summarizeFutureMobileRoute: allSummarizeFutureMobileRoute
      ? { status: 'exact', value: firstDriver.summarizeFutureMobileRoute }
      : { status: 'mixed' },
  }
}
